module.exports = __webpack_public_path__ + "static/media/dots7.87005d30.png";